import axios from "axios";
import { useEffect, useState } from "react";
import { Col, Container, Navbar, Row } from "react-bootstrap";
import { Toaster } from "react-hot-toast";
import { useAuth } from "react-oidc-context";
import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import Dashboard from "./Components/Dashboard/dashboard-component";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import poweredLogo from "./powered-by-stem-logo.svg";

function App() {
	const auth = useAuth();
	const [isAxiosReady, setIsAxiosReady] = useState(false);

	useEffect(() => {
		if (!auth.isAuthenticated && !auth.isLoading && auth.activeNavigator !== "signinRedirect") {
			auth.signinRedirect();
		}
	}, [auth.isAuthenticated, auth.isLoading, auth.activeNavigator, auth.signinRedirect]);

	useEffect(() => {
		if (!auth.isAuthenticated || !auth.user?.id_token) {
			setIsAxiosReady(false);
			return undefined;
		}

		const interceptorId = axios.interceptors.request.use((config) => {
			const updatedConfig = config;
			updatedConfig.headers.Authorization = `Bearer ${auth.user.id_token}`;

			return updatedConfig;
		});

		setIsAxiosReady(true);

		return () => {
			axios.interceptors.request.eject(interceptorId);
			setIsAxiosReady(false);
		};
	}, [auth.isAuthenticated, auth.user?.id_token]);

	if (auth.isAuthenticated) {
		if (!isAxiosReady) {
			return (
				<Container className="py-5">
					<h1>Signing you in…</h1>
					<p>Preparing your secure session.</p>
				</Container>
			);
		}

		return (
			<BrowserRouter>
				<Toaster position="top-right" />
				<div className="app">
					<header className="App-header">
						<Navbar bg="dark" variant="dark">
							<Container>
								<Navbar.Brand>
									<Link to="/" className="nav-link">
										Your impact and evaluation dashboard
									</Link>
								</Navbar.Brand>
							</Container>
						</Navbar>
					</header>
					<Container>
						<Row>
							<Col md={12}>
								<div className="wrapper">
									<Routes>
										<Route exact path="/" element={<Dashboard />} />
									</Routes>
								</div>
							</Col>
						</Row>
					</Container>
					<footer className="app-footer">
						<Container>
							<Row>
								<Col md={6}>
									<img src={poweredLogo} alt="Powerred by STEM Learning" />
								</Col>
								<Col md={6} className="footer-tagline">
									Feedback so we can develop too
								</Col>
							</Row>
						</Container>
					</footer>
				</div>
			</BrowserRouter>
		);
	}

	if (auth.error) {
		return (
			<Container className="py-5">
				<h1>Sign-in failed</h1>
				<p>{auth.error.message}</p>
				<button type="button" className="btn btn-primary" onClick={() => auth.signinRedirect()}>
					Try signing in again
				</button>
			</Container>
		);
	}

	return (
		<Container className="py-5">
			<h1>Signing you in…</h1>
			<p>Please wait while we redirect you to the authentication service.</p>
			{!auth.isLoading && auth.activeNavigator !== "signinRedirect" ? (
				<button type="button" className="btn btn-primary" onClick={() => auth.signinRedirect()}>
					Sign in
				</button>
			) : null}
		</Container>
	);
}

export default App;
